import styled from "styled-components";
import { Icon } from "@vds/icons";

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 5%;
`;

const EventsTile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 28.5rem;
  height: 6.75rem;
  padding: 1rem;
  overflow-y: hidden;
  overflow-x: hidden;
  border-radius: 0.5rem;
  background: var(--vds-background-primary-light, #fff);
  margin-bottom: 1rem;
  gap: 1.25rem;
`;

const DropDownContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  gap: 0.2rem;
`;

const RectangleOne = styled.div`
  width: 100%;
  height: 1.125rem;
  background-color: #f1f1f1;
  @media (min-width: 1024px) {
    width: 10rem;
  }
`;

const RectangleTwoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.2rem;
`;

const RectangleTwo = styled.div`
  width: 100%;
  height: 1.125rem;
  background-color: #e5e5e5;
  @media (min-width: 1024px) {
    width: 14rem;
  }
`;

const RectangleThreeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const RectangleThree = styled.div`
  width: 100%;
  height: 1.125rem;
  background-color: #e5e5e5;
  @media (min-width: 1024px) {
    width: 13rem;
  }
`;

const EventTileContent = () => (
  <DropDownContent>
    <RectangleOne />
    <RectangleTwoContainer>
      <RectangleTwo />
      <Icon name="down-caret" size="large" color="#D8DADA" />
    </RectangleTwoContainer>
    <RectangleThreeContainer>
      <RectangleThree />
      <Icon name="location" size="medium" color="#D8DADA" />
    </RectangleThreeContainer>
  </DropDownContent>
);

const DashboardEventRowEmpty = () => {
  const tiles = [1, 2, 3, 4];
  return (
    <DashboardContainer>
      {tiles.map((tile, index) => (
        <EventsTile key={index}>
          <EventTileContent />
        </EventsTile>
      ))}
    </DashboardContainer>
  );
};

export default DashboardEventRowEmpty;
